/* unplugin-vue-components disabled */import { render } from "./GHSubCategory.vue?vue&type=template&id=1ded7226&scoped=true"
import script from "./GHSubCategory.vue?vue&type=script&lang=js"
export * from "./GHSubCategory.vue?vue&type=script&lang=js"

import "./GHSubCategory.vue?vue&type=style&index=0&id=1ded7226&scoped=true&lang=css"

import exportComponent from "/home/runner/work/gh-docs-frontend/gh-docs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ded7226"]])

export default __exports__